/** A column map heading: what it means, and whether and how an administrator can change it. */
export interface ColumnMapHeading {
	title: string
	meaning: string
	change: string
}

/** The column map table's headings, in order; both the heading tooltips and the help panel read them. */
export const COLUMN_MAP_HEADINGS: ColumnMapHeading[] = [
	{
		title: 'Excel column',
		meaning: "The header in row 1 of the tab, exactly as written. Spaces at either end don't matter.",
		change: "Editable. Change it when the tab's header changes, or the sync skips the tab.",
	},
	{
		title: 'Axis',
		meaning:
			'What the column says about the row: its country (geography), its brand or product (brand), its species, or the file type of the assets it lists (file_type).',
		change: 'Fixed. Changing it is a seed change.',
	},
	{
		title: 'Value',
		meaning:
			'For an asset column, the file type every file in it is tagged with. "From the cell" means the cell\'s text is matched to a value of the axis.',
		change: 'Editable on asset columns: pick another file type.',
	},
	{
		title: 'Level',
		meaning:
			"For an asset column, what its files are tagged with besides the file type: product (the row's country, species and product), brand (country, species and brand) or market (country only, such as the company logo).",
		change: 'Editable on asset columns.',
	},
	{
		title: 'Reading',
		meaning:
			"How the cell is read. Required: an empty cell blocks the row. Brands only: match brands, not products. Under: match the products of that column's brand. Split on: read each part on its own. Ignore: skip parts such as NA.",
		change: 'Editable.',
	},
]
